import axios from "@/plugins/axios.js";

export default {
    postCustomer(payload) {
        return axios.post('user/customer', payload);
    }
}